import { Country, CountryDialCode } from '../constants/country';

export const formatE164PhoneNumber = (phoneNumber: string, countryCode: Country): string => {
  if (process.env.NODE_ENV === 'development') {
    return `+82${phoneNumber}`;
  }
  const dialCode = CountryDialCode[countryCode];
  return `${dialCode}${phoneNumber}`;
};
